import i18n from 'i18next'

export const caseLabels = {
    '-': '',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    'X': '',
}

export const fullCaseLabels = {
    '-': '',
    '1': 'nominative',
    '2': 'genitive',
    '3': 'dative',
    '4': 'accusative',
    '5': 'vocative',
    '6': 'locative',
    '7': 'instrumental',
    'X': '',
}

export const numLabels = {
    'S': 'singular',
    'D': 'dual',
    'P': 'plural',
    'W': 'singular feminine or plural neuter',
    'X': '',
    '-': ''
}

export const typeLabels = {
    'A': 'common adjective',
    'C': 'nominal form',
    'e': 'present transgressive', // transgressive
    'm': 'past transgressive',  // transgressive
    'p': 'past participle',
    'q': 'past participle (arch.)',
    'B': 'present/future',
    't': 'present/future (arch.)',
    'i': 'imperative',
    'f': 'infinitive',
    's': 'n-participle (passive)',
    'c': 'conditional ("to be")',
    '-': ''
}

export const negLabels = {
    'A': 'affirmative',
    'N': 'negative',
    '-': ''
}

export const persLabels = {
    '1': '1.p.',
    '2': '2.p.',
    '3': '3.p.',
    'X': '',
    '-': ''
}

export const modeLabels = {
    'A': 'active',
    'P': 'passive',
    '-': ''
}

export const tempLabels = {
    'F': 'future',
    'H': 'present or past',
    'P': 'present',
    'R': 'past',
    'X': '',
    '-': ''
}

export const degLabels = {
    '1': 'positive',
    '2': 'comparative',
    '3': 'superlative',
    '-': ''
}

export const genLabels = {
    'M': 'masculine animate',
    'I': 'masculine inanimate',
    'F': 'feminine',
    'N': 'neuter',
    'H': 'feminine or neuter',
    'Q': 'feminine sg. or neuter pl.',
    'T': 'masc. in. or fem.',
    'X': '',
    'Y': 'masculine',
    'Z': 'non-feminine',
    '-': ''
}

export function cnctag2labels(tag: string): string[]  {
    const [pos, type, gen, num, nCase, posGen, posNum, pers, time, deg, neg, mode, void1, void2, variant, aspect] = tag.split('')
    let labels: string[] = []
    if ( pos === 'N' ) {
        labels.push('noun')
        labels.push(genLabels[gen])
        labels.push(numLabels[num])
        labels.push(fullCaseLabels[nCase])
    } else if ( pos === 'A' ) {
        labels.push('adjective')
        if ( type === 'C' ) {
            labels.push(typeLabels[type])
        }
        labels.push(negLabels[neg])
        labels.push(degLabels[deg])
        labels.push(genLabels[gen])
        labels.push(numLabels[num])
        labels.push(fullCaseLabels[nCase])
    } else if ( pos === 'P' ) {
        labels.push('pronoun')
        labels.push(genLabels[gen])
        labels.push(numLabels[num])
        labels.push(fullCaseLabels[nCase])
    } else if ( pos === 'C' ) {
        labels.push('numeral')
        labels.push(genLabels[gen])
        labels.push(numLabels[num])
        labels.push(fullCaseLabels[nCase])
    } else if ( pos === 'V' ) {
        labels.push('verb')
        labels.push(negLabels[neg])
        labels.push(typeLabels[type])
        labels.push(genLabels[gen])
        labels.push(numLabels[num])
        labels.push(persLabels[pers])
        labels.push(fullCaseLabels[nCase])
    } else if ( pos === 'D' ) {
        labels.push('adverb')
        labels.push(negLabels[neg])
        labels.push(degLabels[deg])
    } else if ( pos === 'R' ) {
        labels.push('preposition')
    } else if ( pos === 'J' ) {
        labels.push('conjuction')
    } else if ( pos === 'T' ) {
        labels.push('particle')
    } else if ( pos === 'I' ) {
        labels.push('interjection')
    } else {
        labels.push('unknown form')
    }
    return labels.filter(e => e)
}


export const transgressives = ['e', 'm']

export const caseOrder = ['-', '1', '2', '3', '4', '5', '6', '7', 'X'] // 5
export const numOrder = ['S', 'D', 'P', 'W', 'X', '-'] //  4
export const varOrder = ['-', '1', '2', '3', '4', '5', '6', '7', '8', '9'] // 15
export const negOrder = ['A', 'N', '-'] // 11
export const degOrder = ['1', '2', '3', '-'] // 10
export const genOrder = ['M', 'I', 'F', 'N', 'H', 'Q', 'T', 'X', 'Y', 'Z', '-'] // 3
//export const posgenOrder = ['M', 'F', 'Z', 'X', '-'] // 6
//export const posnumOrder = ['S', 'P', '-'] // 7
export const persOrder = ['-', '1', '2', '3', 'X'] // 8
export const tempOrder = ['P', 'H', 'R', 'F', 'X', '-'] // 9
export const modeOrder = ['A', 'P', '-'] //12
//const aspOrder = ['I', 'P', 'B', '-'] // 16
export const typeOrder = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'H', 'Q', 'R', 'S', 'T', 'U', 
                   'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 
                   'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '7', '6', '8', '9', '!',
                   '*', ',', '.', ':', ';', '=', '?', '^', '}', '~', '@', '-'] // 2

export const orderN = (a: object, b: object) : number => {
    const aGen = a['tag'].charAt(2)
    const bGen = b['tag'].charAt(2)
    const genDiff = genOrder.indexOf(aGen) - genOrder.indexOf(bGen)
    if (genDiff !== 0)
        return genDiff
    const aNum = a['tag'].charAt(3)
    const bNum = b['tag'].charAt(3)
    const numDiff = numOrder.indexOf(aNum) - numOrder.indexOf(bNum)
    if (numDiff !== 0)
        return numDiff
    const aCase = a['tag'].charAt(4)
    const bCase = b['tag'].charAt(4)
    const caseDiff = caseOrder.indexOf(aCase) - caseOrder.indexOf(bCase)
    if (caseDiff !== 0)
        return caseDiff
    const aVar = a['tag'].charAt(14)
    const bVar = b['tag'].charAt(14)
    const varDiff = varOrder.indexOf(aVar) - varOrder.indexOf(bVar)
    if (varDiff !== 0)
        return varDiff
    return b['total'] - a['total']
}

export const orderA = (a: object, b: object) : number => {
    const aType = a['tag'].charAt(1)
    const bType = b['tag'].charAt(1)
    const typeDiff = typeOrder.indexOf(aType) - typeOrder.indexOf(bType)
    if (typeDiff !== 0)
        return typeDiff
    const aNeg = a['tag'].charAt(10)
    const bNeg = b['tag'].charAt(10)
    const negDiff = negOrder.indexOf(aNeg) - negOrder.indexOf(bNeg)
    if (negDiff !== 0)
        return negDiff
    const aDeg = a['tag'].charAt(9)
    const bDeg = b['tag'].charAt(9)
    const degDiff = degOrder.indexOf(aDeg) - degOrder.indexOf(bDeg)
    if (degDiff !== 0)
        return degDiff
    const aGen = a['tag'].charAt(2)
    const bGen = b['tag'].charAt(2)
    const genDiff = genOrder.indexOf(aGen) - genOrder.indexOf(bGen)
    if (genDiff !== 0)
        return genDiff
    const aNum = a['tag'].charAt(3)
    const bNum = b['tag'].charAt(3)
    const numDiff = numOrder.indexOf(aNum) - numOrder.indexOf(bNum)
    if (numDiff !== 0)
        return numDiff
    const aCase = a['tag'].charAt(4)
    const bCase = b['tag'].charAt(4)
    const caseDiff = caseOrder.indexOf(aCase) - caseOrder.indexOf(bCase)
    if (caseDiff !== 0)
        return caseDiff
    const aVar = a['tag'].charAt(14)
    const bVar = b['tag'].charAt(14)
    const varDiff = varOrder.indexOf(aVar) - varOrder.indexOf(bVar)
    if (varDiff !== 0)
        return varDiff
    return b['total'] - a['total']
}

export const orderP = (a: object, b: object) : number => {
    const aGen = a['tag'].charAt(2)
    const bGen = b['tag'].charAt(2)
    const genDiff = genOrder.indexOf(aGen) - genOrder.indexOf(bGen)
    if (genDiff !== 0)
        return genDiff
    const aNum = a['tag'].charAt(3)
    const bNum = b['tag'].charAt(3)
    const numDiff = numOrder.indexOf(aNum) - numOrder.indexOf(bNum)
    if (numDiff !== 0)
        return numDiff
    const aCase = a['tag'].charAt(4)
    const bCase = b['tag'].charAt(4)
    const caseDiff = caseOrder.indexOf(aCase) - caseOrder.indexOf(bCase)
    if (caseDiff !== 0)
        return caseDiff
    const aType = a['tag'].charAt(1)
    const bType = b['tag'].charAt(1)
    const typeDiff = typeOrder.indexOf(aType) - typeOrder.indexOf(bType)
    if (typeDiff !== 0)
        return typeDiff
    const aVar = a['tag'].charAt(14)
    const bVar = b['tag'].charAt(14)
    const varDiff = varOrder.indexOf(aVar) - varOrder.indexOf(bVar)
    if (varDiff !== 0)
        return varDiff
    return b['total'] - a['total']
}

export const orderV = (a: object, b: object) : number => {
    const aNeg = a['tag'].charAt(10)
    const bNeg = b['tag'].charAt(10)
    const negDiff = negOrder.indexOf(aNeg) - negOrder.indexOf(bNeg)
    if (negDiff !== 0)
        return negDiff
    const aMode = a['tag'].charAt(11)
    const bMode = b['tag'].charAt(11)
    const modeDiff = modeOrder.indexOf(aMode) - modeOrder.indexOf(bMode)
    if (modeDiff !== 0)
        return modeDiff
    const aTemp = a['tag'].charAt(8)
    const bTemp = b['tag'].charAt(8)
    const tempDiff = tempOrder.indexOf(aTemp) - tempOrder.indexOf(bTemp)
    if (tempDiff !== 0)
        return tempDiff
    const aType = a['tag'].charAt(1)
    const bType = b['tag'].charAt(1)
    const typeDiff = typeOrder.indexOf(aType) - typeOrder.indexOf(bType)
    if (transgressives.includes(aType) && transgressives.includes(bType) && typeDiff !== 0)
        return typeDiff
    const aGen = a['tag'].charAt(2)
    const bGen = b['tag'].charAt(2)
    const genDiff = genOrder.indexOf(aGen) - genOrder.indexOf(bGen)
    if (genDiff !== 0)
        return genDiff
    const aNum = a['tag'].charAt(3)
    const bNum = b['tag'].charAt(3)
    const numDiff = numOrder.indexOf(aNum) - numOrder.indexOf(bNum)
    if (numDiff !== 0)
        return numDiff
    const aPers = a['tag'].charAt(7)
    const bPers = b['tag'].charAt(7)
    const persDiff = persOrder.indexOf(aPers) - persOrder.indexOf(bPers)
    if (persDiff !== 0)
        return persDiff
    const aCase = a['tag'].charAt(4)
    const bCase = b['tag'].charAt(4)
    const caseDiff = caseOrder.indexOf(aCase) - caseOrder.indexOf(bCase)
    if (caseDiff !== 0)
        return caseDiff
    const aVar = a['tag'].charAt(14)
    const bVar = b['tag'].charAt(14)
    const varDiff = varOrder.indexOf(aVar) - varOrder.indexOf(bVar)
    if (varDiff !== 0)
        return varDiff
    return b['total'] - a['total']
}

export const orderD = (a: object, b: object) : number => {
    const aNeg = a['tag'].charAt(10)
    const bNeg = b['tag'].charAt(10)
    const negDiff = negOrder.indexOf(aNeg) - negOrder.indexOf(bNeg)
    if (negDiff !== 0)
        return negDiff
    const aDeg = a['tag'].charAt(9)
    const bDeg = b['tag'].charAt(9)
    const degDiff = degOrder.indexOf(aDeg) - degOrder.indexOf(bDeg)
    if (degDiff !== 0)
        return degDiff
    const aVar = a['tag'].charAt(14)
    const bVar = b['tag'].charAt(14)
    const varDiff = varOrder.indexOf(aVar) - varOrder.indexOf(bVar)
    if (varDiff !== 0)
        return varDiff
    return b['total'] - a['total']
}

export const headerN = (current: object, previous: object) => {
    const gen = current['tag'].charAt(2)
    const c = current['tag'].charAt(4)
    const n = current['tag'].charAt(3)
    //const np = previous['tag'] ? previous['tag'].charAt(3) : null
    const hTag = [gen, n].join('')
    current['hTag'] = hTag
    if (hTag !== previous['hTag']) {
        const hLabel = [i18n.t(genLabels[gen]), i18n.t(numLabels[n])].join(' - ')
        return [hLabel, i18n.t(caseLabels[c])]
    } else {
        return [null, caseLabels[c]]
    }
}

export const headerA = (current: object, previous: object) => {
    const ncase = current['tag'].charAt(4)
    const num = current['tag'].charAt(3)
    const type = current['tag'].charAt(1)
    const neg = current['tag'].charAt(10)
    const deg = current['tag'].charAt(9)
    const gen = current['tag'].charAt(2)
    //const np = previous['tag'] ? previous['tag'].charAt(3) : null
    const hTag = [type, neg, deg, gen, num].join('')
    current['hTag'] = hTag
    if (hTag !== previous['hTag']) {
        let hLabel = ''
        if (['A', 'G', 'M', 'U'].includes(type)) {
            hLabel = [i18n.t(genLabels[gen]), i18n.t(numLabels[num])].filter(Boolean).join(' - ')
        } else {
            hLabel = [i18n.t(typeLabels[type]), i18n.t(genLabels[gen]), i18n.t(numLabels[num])].filter(Boolean).join(' - ')
        }
        return [hLabel, i18n.t(caseLabels[ncase])]
    } else {
        return [null, i18n.t(caseLabels[ncase])]
    }
}

export const headerP = (current: object, previous: object) => {
    const ncase = current['tag'].charAt(4)
    const num = current['tag'].charAt(3)
    const gen = current['tag'].charAt(2)
    const hTag = [gen, num].join('')
    current['hTag'] = hTag
    if (hTag !== previous['hTag']) {
        let hLabel = ''
        hLabel = [i18n.t(genLabels[gen]), i18n.t(numLabels[num])].filter(Boolean).join(' - ')
        return [hLabel, i18n.t(caseLabels[ncase])]
    } else {
        return [null, i18n.t(caseLabels[ncase])]
    }
}

export const headerV = (current: object, previous: object) => {
    const pers = current['tag'].charAt(7)
    const num = current['tag'].charAt(3)
    let type = current['tag'].charAt(1)
    const neg = current['tag'].charAt(10)
    //const mode = current['tag'].charAt(11)
    //const temp = current['tag'].charAt(8)
    const gen = current['tag'].charAt(2)
    const ncase = current['tag'].charAt(4)
    if (!transgressives.includes(type))
        type = '-'
    const hTag = [neg, type, gen, num].join('')
    current['hTag'] = hTag
    let rLabel = i18n.t(persLabels[pers])
    if (caseLabels[ncase])
        rLabel = rLabel + " (" +  caseLabels[ncase] + ")"
    if (hTag !== previous['hTag']) {
        const hLabel = [i18n.t(negLabels[neg]), i18n.t(typeLabels[type]), i18n.t(genLabels[gen]), i18n.t(numLabels[num])].filter(Boolean).join(' - ')
        return [hLabel, rLabel]
    } else {
        return [null, rLabel]
    }
}

export const headerD = (current: object, previous: object) => {
    const neg = current['tag'].charAt(10)
    const deg = current['tag'].charAt(9)
    const hTag = neg
    current['hTag'] = hTag
    if (hTag !== previous['hTag']) {
        let hLabel = ''
        hLabel = i18n.t(negLabels[neg])
        return [hLabel, i18n.t(degLabels[deg])]
    } else {
        return [null, i18n.t(degLabels[deg])]
    }
}

export const orderDefault = (a: object, b: object) : number => {
    return (a['tag'] === b['tag'] ? 0 : 1)
}

export const headerDefault = (current: object, previous: object) => {
    return [null, null]
}

export const sortFunc = {
    'N': orderN,
    'A': orderA,
    'P': orderP,
    'C': orderP,
    'V': orderV,
    'D': orderD,
    'R': orderDefault,
    'J': orderDefault,
    'T': orderDefault,
    'I': orderDefault,
    'X': orderDefault,
    'Z': orderDefault
}

export const headerFunc = {
    'N': (cur: object, prev: object) => headerN(cur, prev),
    'A': (cur: object, prev: object) => headerA(cur, prev),
    'P': (cur: object, prev: object) => headerP(cur, prev),
    'C': (cur: object, prev: object) => headerP(cur, prev),
    'V': (cur: object, prev: object) => headerV(cur, prev),
    'D': (cur: object, prev: object) => headerD(cur, prev),
    'R': (cur: object, prev: object) => headerDefault(cur, prev),
    'J': (cur: object, prev: object) => headerDefault(cur, prev),
    'T': (cur: object, prev: object) => headerDefault(cur, prev),
    'I': (cur: object, prev: object) => headerDefault(cur, prev),
    'X': (cur: object, prev: object) => headerDefault(cur, prev),
    'Z': (cur: object, prev: object) => headerDefault(cur, prev)
}